"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResurrectEffectHandler = exports.ResurrectEffectArgs = void 0;
const __1 = require("../../..");
const Duration_1 = require("../../Duration");
const AttributeType_1 = require("../../enums/AttributeType");
const Resurrected_1 = require("../../events/core/Resurrected");
const Registries_1 = require("../../state/Registries");
const Target_1 = require("../../Target");
const EffectType_1 = require("../EffectType");
const RemoveEffectsOfType_1 = require("./RemoveEffectsOfType");
const TurnMeterDecrease_1 = require("./TurnMeterDecrease");
const TurnMeterIncrease_1 = require("./TurnMeterIncrease");
class ResurrectEffectArgs {
    constructor(abilityKey, percentHealthAfterResurrection = 100) {
        this.abilityKey = abilityKey;
        this.percentHealthAfterResurrection = percentHealthAfterResurrection;
        this.__type = EffectType_1.EffectType.Resurrect;
        this.__typeName = "Resurrect";
        this.name = "Resurrect";
        this.harmful = false;
        this.removeSupernaturalDeath = false;
    }
}
exports.ResurrectEffectArgs = ResurrectEffectArgs;
let ResurrectEffectHandler = class ResurrectEffectHandler {
    apply(sequence, container, state) {
        const isDead = container.hasEffectOfType(state.targetId, EffectType_1.EffectType.Death);
        if (!isDead) {
            throw new Error(`TARGET_NOT_DEAD => actorId:${state.targetId}`);
        }
        const isDeathSupernatural = container.getEffect(container.getEffectsOfType(state.targetId, EffectType_1.EffectType.Death)[0]).supernatural;
        if (!state.args.removeSupernaturalDeath && isDeathSupernatural) {
            return;
        }
        const afterResurrectionHealth = container.getMaxAttributeScore(state.targetId, AttributeType_1.AttributeType.Health) * ((state.args.percentHealthAfterResurrection) / 100);
        container.applyBuff({
            sequence,
            creatorId: state.creatorId,
            targetId: state.targetId,
            effect: new RemoveEffectsOfType_1.RemoveEffectsOfTypeEffectArgs(EffectType_1.EffectType.Death, false),
            duration: Duration_1.Duration.Instant,
        });
        const turnMeterBefore = container.getTurnMeter(state.targetId);
        if (turnMeterBefore < 0) {
            container.applyEffect(sequence, state.creatorId, state.targetId, new TurnMeterIncrease_1.TurnMeterIncreaseEffectArgs(turnMeterBefore * -1), Duration_1.Duration.Instant);
        }
        else if (turnMeterBefore > 0) {
            container.applyEffect(sequence, state.creatorId, state.targetId, new TurnMeterDecrease_1.TurnMeterDecreaseEffectArgs(turnMeterBefore), Duration_1.Duration.Instant);
        }
        container.applyHealing({
            sequence,
            healerId: state.creatorId,
            targetId: state.targetId,
            amount: afterResurrectionHealth
        });
        // Need to call init on abilities in case they are passive
        container.initAbilities(sequence, state.targetId);
        container.emitEvent(sequence, state.targetId, new Resurrected_1.ResurrectedEventArgs(state.creatorId));
        for (const ally of container.selectTargets(state.targetId, Target_1.Target.AllAllies)) {
            container.emitEvent(sequence, ally, new __1.AllyResurrectedEventArgs(state.targetId));
        }
        for (const enemy of container.selectTargets(state.targetId, Target_1.Target.AllEnemies)) {
            container.emitEvent(sequence, enemy, new __1.EnemyResurrectedEventArgs(state.targetId));
        }
    }
    remove(sequence, container, state) {
        // TODO: Is this even possible?
    }
};
ResurrectEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Resurrect)
], ResurrectEffectHandler);
exports.ResurrectEffectHandler = ResurrectEffectHandler;
